import "./Custom.css";
const NoItemsDisplay = ({ children, textItems }) => {
  return (
    <div className="no-items-display">
      {children}
      {textItems.map((item) => {
        return (
          <p className="mb-0" key={item}>
            {item}
          </p>
        );
      })}
    </div>
  );
};

export default NoItemsDisplay;
